import { IClubDto } from "../common/interfaces/clubs-wizard.interface";
import {
  GetUserDetailsDto,
  IBasicClubData,
  IClubBasicInfoDto,
  IClubCreationData,
  IUpdateClubDto,
} from "../common/interfaces/clubs.interface";
import {
  CLUBS_BASE_URL,
  DASHBOARD_CLUBS_URL,
  USERS_BASE_URL,
} from "./utilities/app.urls";
import failedClub from "./failedClub.json";

import { get, patch, post } from "./utilities/http";

/**
 * Create a club
 * @param data {IClubDto}
 * @return {Promise<IUpdateClubDto>}
 */
export function createClub(data: IClubDto): Promise<IUpdateClubDto> {
  return post(CLUBS_BASE_URL, data);
}

/**
 * Update club basic info
 * @param data {IUpdateClubDto}
 * @param clubAddress {string}
 * @return {Promise<IClubBasicInfoDto>}
 */
export function updateClub(
  data: IUpdateClubDto,
  clubAddress: string
): Promise<IClubBasicInfoDto> {
  return patch(`${CLUBS_BASE_URL}/${clubAddress}`, data);
}

/**
 * Get all clubs
 * @returns {Promise<IBasicClubData[]>}
 */

export function getClubs(): Promise<IBasicClubData[]> {
  return get(CLUBS_BASE_URL);
}
/**
 * @param clubAddress: string
 * @returns {Promise<IClubBasicInfoDto>}
 */
export function getClubInfo(clubAddress: string): Promise<IClubBasicInfoDto> {
  return get(`${CLUBS_BASE_URL}/${clubAddress}`);
}

/**
 * Get all club members
 * @param data {GetUserDetailsDto}
 * @return {Promise<{name: string, imageUrl: string}[]>}
 */
export function getAllClubMembers(data: GetUserDetailsDto) {
  return post(`${USERS_BASE_URL}/details`, data);
}

/**
 * Get all clubs
 * @returns {Promise<IBasicClubData[]>}
 */

export function getDashboardClubs(): Promise<IBasicClubData[]> {
  return get(DASHBOARD_CLUBS_URL);
}

export async function getClubData(clubAddress: string) {
  //return get(`club-data/${clubAddress}`)
  return { ...failedClub, clubConfig: JSON.stringify(failedClub.clubConfig) };
}

export function createClubData(data: IClubCreationData) {
  return post(`${"club-data"}/create-club-data`, data);
}
